import PropTypes from 'prop-types'
import { FormattedMessage, useIntl } from 'react-intl'

const cssClass = [
  'vst-btn--medium',
  'vs-btn--blue',
  'd-display-inline-block'
].join(' ')

const AddToCart = ({ action, title }) => {
  const intl = useIntl()
  const ariaLabeltext = intl.formatMessage({ id: 'carts.add_to_cart' })

  return (
    <button
      aria-label={`${ariaLabeltext} - ${title}`}
      className={cssClass}
      onClick={action}
    >
      <FormattedMessage id='carts.add_to_cart' />
    </button>
  )
}

export default AddToCart

AddToCart.propTypes = {
  action: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired
 }
